export const getters = {
  financialInstitutionId: ({ selectedFinancialInstitutionId }) => selectedFinancialInstitutionId,
  plaidInstitutionId: ({ selectedPlaidInstitutionId }) => selectedPlaidInstitutionId,
  plaidAccountIds: ({ selectedPlaidAccountIds }) => selectedPlaidAccountIds,
  checkingBankAccounts: ({ checkingBankAccounts }) => checkingBankAccounts
}
